var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9987 11.3335H18.6654V4.00016C18.6654 3.0277 18.2791 2.09507 17.5914 1.40744C16.9038 0.719804 15.9712 0.333496 14.9987 0.333496C14.0262 0.333496 13.0936 0.719804 12.406 1.40744C11.7183 2.09507 11.332 3.0277 11.332 4.00016L11.4622 11.3335H3.9987C3.02624 11.3335 2.09361 11.7198 1.40597 12.4074C0.71834 13.0951 0.332031 14.0277 0.332031 15.0002C0.332031 15.9726 0.71834 16.9053 1.40597 17.5929C2.09361 18.2805 3.02624 18.6668 3.9987 18.6668L11.4622 18.5367L11.332 26.0002C11.332 26.9726 11.7183 27.9053 12.406 28.5929C13.0936 29.2805 14.0262 29.6668 14.9987 29.6668C15.9712 29.6668 16.9038 29.2805 17.5914 28.5929C18.2791 27.9053 18.6654 26.9726 18.6654 26.0002V18.5367L25.9987 18.6668C26.9712 18.6668 27.9038 18.2805 28.5914 17.5929C29.2791 16.9053 29.6654 15.9726 29.6654 15.0002C29.6654 14.0277 29.2791 13.0951 28.5914 12.4074C27.9038 11.7198 26.9712 11.3335 25.9987 11.3335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ac0fb49281d7461c7d5aa8be4f1b9966.svg";
export { ForwardRef as ReactComponent };